<template>
  <div
    v-loading="loading"
    class="r-menu-items"
  >
    <p class="menu-tltle">
      权限
    </p>
    <table
      class="menu-table"
      cellspacing="0"
      cellpadding="0"
    >
      <tbody>
        <menu-item-row
          v-for="(tr, idx) in menuItems"
          :key="idx"
          :row="tr"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import MenuItemRow from './children/MenuItemRow';
import api from './proxy';
export default {
    name: 'MenuItems',
    components: { MenuItemRow },
    props: {
        promise: {
            type: Array,
            required: true,
        },
    },
    data () {
        return {
            checkedMenu: [],
            menuItems: [],
            loading: true,
        };
    },
    mounted () {
        api.getActionList({
            appCode: this.$store.getters['system/appCode'],
        }).then(data => {
            let defa = this.promise.map(itm => itm.actionId);
            if (this.$store.getters['system/appCode'] === '006') {
                // 习题管理的非优学派身份，不能编辑题库属性和自建资源
                if (this.$store.getters['global/orgId'] !== '1') {
                    this.menuItems.splice(0, 2);
                    data.data.list = data.data.list.filter(item => {
                        return !['00603', '00604'].includes(item.code);
                    });
                }
            };
            if (this.$store.getters['system/appCode'] === '042') {
                // 网页管理的非优学派身份，不能设置模板管理权限
                if (this.$store.getters['global/orgId'] !== '1') {
                    this.menuItems.splice(0, 2);
                    data.data.list = data.data.list.filter(item => {
                        return !['04202'].includes(item.code);
                    });
                }
            };
            this.menuItems = data.data.list.map(itm => {
                let actions = itm.actions || [];
                actions.forEach(op => {
                    op.checked = defa.includes(op.actionId);
                });
                return itm;
            });
            this.loading = false;
        });
    },
    methods: {
        getCheckedModules () {
            let arr = [];
            this.menuItems.forEach(itm => {
                arr.push(...itm.actions.filter(a => a.checked));
            });
            return arr;
        },
    },
};
</script>

<style scoped lang="scss">
  @import "../../../sass/theme.scss";

  .r-menu-items {
    min-height: 200px;
  }
  .menu-tltle {
    border: 1px solid #ebeef5 {
      bottom-color: transparent;
    };
    padding: 10px 15px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: $light-primary;
  }
  .menu-table {
    width: 100%;
  }
</style>
